"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrendMobileDown = function TrendMobileDown() {
  return _react2.default.createElement(
    "g",
    { id: "trend-mobile-down", fill: "#ff632d" },
    _react2.default.createElement("polygon", { id: "Shape", points: "321.14 250.65 321.14 0 178.28 0 178.28 250.65 64 250.65 249.71 500 435.43 250.65" })
  );
};

exports.default = TrendMobileDown;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/TrendMobileDown.js
// module id = 3000
// module chunks = 4